import { isInProgressApplicationState } from "@lending/utils/applicationState";
import type { LoanPortalApplication, LoanPortalStatus } from "./types";
import type { StateEnum } from "@lending/types";

/**
 * Map a backend application state to its portal-facing status. Terminal states
 * are "submitted"; everything else is "incomplete".
 */
export function getLoanPortalStatus(state: StateEnum): LoanPortalStatus {
  return isInProgressApplicationState(state) ? "incomplete" : "submitted";
}

/**
 * Whether an application belongs in the dashboard's "needs attention" card.
 *
 * Defined positively (incomplete applications need attention) so that adding a
 * new `LoanPortalStatus` is a deliberate decision rather than silently landing
 * in the attention card. Because `loanPortalStatus` is derived from
 * `isInProgressApplicationState`, this is equivalent to "the application is not in a terminal
 * state".
 */
export function needsAttention(application: LoanPortalApplication): boolean {
  return application.loanPortalStatus === "incomplete";
}
